import clsx from 'clsx'

import styles from './chips.module.scss'

interface IChipsProps {
    active?: number | string
    chips: {
        subTitle?: string
        value: number | string
    }[]
    className?: string
    itemsClassName?: string
    setValue: (amount: number | string) => void
    subTitle?: string
}

export const Chips = ({
    chips,
    setValue,
    active,
    className,
    itemsClassName,
}: IChipsProps): React.ReactNode => {
    return (
        <div className={clsx(styles.chips, className)}>
            {chips.map((chip) => (
                <ChipsItem
                    key={chip.value}
                    active={active}
                    className={itemsClassName}
                    item={chip.value}
                    subTitle={chip.subTitle}
                    onClick={() => {
                        setValue(chip.value)
                    }}
                />
            ))}
        </div>
    )
}

interface IChipsItemProps {
    active?: number | string
    className?: string
    item: number | string
    onClick: () => void
    subTitle?: string
}

export const ChipsItem = ({
    item,
    active,
    onClick,
    className,
    subTitle,
}: IChipsItemProps): React.ReactNode => {
    return (
        <button
            aria-label={`Select ${item}`}
            type='button'
            className={clsx(
                styles.chips__item,
                active === item && styles['chips__item_active'],
                className,
            )}
            onClick={onClick}
        >
            {item}
            {subTitle && <span className={styles['chips__item--subtitle']}>{subTitle}</span>}
        </button>
    )
}
